import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleActiveTab, setEventsListStartIndex, setSelectedEvent } from '../../store/statsSlice.js';
import Menu from '../../components/menu/menu';
import Content from '../../components/content/content';
import './Stats.css'
import {
    PieChart, Pie, Cell,
    Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";


import UniversalLineWithComponents from '../../components/components/universal_line_with_components/universalLineWithComponents.jsx';
import customText from '../../components/components/custom_text/customText.jsx';

import { ReactComponent as ThreePeople } from '../../components/icons/people.svg';
import { ReactComponent as StatusUp } from '../../components/icons/status-up.svg';
import { ReactComponent as Chart } from '../../components/icons/chart.svg';

import CustomTile  from "../../components/components/custom_tile/customTile";
import Column from "../../components/components/column_layout/column.jsx";
import ColumnLayout from "../../components/components/column_layout/columnLayout.jsx";

import ApiService from '../../components/api_services/apiService';
import CustomDropdown from "../../components/components/custom_list/customDropdown";

const InfoModal = ({ isOpen, onClose, title, description }) => {
    if (!isOpen) return null;

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
            }}
            onClick={onClose}
        >
            <div
                style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    padding: '24px',
                    maxWidth: '500px',
                    width: '90%',
                    position: 'relative',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '16px',
                        right: '16px',
                        background: 'none',
                        border: 'none',
                        fontSize: '24px',
                        cursor: 'pointer',
                        color: '#666',
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '50%',
                        transition: 'background-color 0.2s',
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                    ×
                </button>

                <h3 style={{
                    marginTop: 0,
                    marginBottom: '16px',
                    color: '#333',
                    fontSize: '20px',
                    fontWeight: 'bold',
                }}>
                    {title}
                </h3>

                <p style={{
                    margin: 0,
                    color: '#666',
                    lineHeight: '1.6',
                    fontSize: '15px',
                }}>
                    {description}
                </p>
            </div>
        </div>
    );
};

// Komponent InfoIcon - mała ikonka "i" w kółeczku
const InfoIcon = ({ onClick }) => {
    return (
        <button
            onClick={onClick}
            style={{
                width: '20px',
                minWidth: '20px',
                height: '20px',
                minHeight: '20px',
                borderRadius: '50%',
                border: '2px solid #EE8F3B',
                backgroundColor: 'white',
                color: '#EE8F3B',
                fontSize: '12px',
                fontWeight: 'bold',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'all 0.2s',
                padding: 0,
                verticalAlign: 'middle',
                marginLeft: 'auto'
            }}
            onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#EE8F3B';
                e.target.style.color = 'white';
            }}
            onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'white';
                e.target.style.color = '#EE8F3B';
            }}
        >
            i
        </button>
    );
};

function Stats() {
    const dispatch = useDispatch();
    const activeTab = useSelector((state) => state.stats.activeTab);
    const activeChart = useSelector((state) => state.stats.activeChart);
    const eventsListStartIndex = useSelector((state) => state.stats.eventsListStartIndex);
    const selectedEventId = useSelector((state) => state.stats.selectedEventId);

    const [dropdown1Value, setDropdown1Value] = useState('0');
    const [dropdown2Value, setDropdown2Value] = useState('LAST_7_DAYS');
    const [dropdown3Value, setDropdown3Value] = useState('0');

    const [showViewsModal, setShowViewsModal] = useState(false);
    const [showUsersModal, setShowUsersModal] = useState(false);
    const [showUsers2Modal, setShowUsers2Modal] = useState(false);

    const [showRank1Modal, setShowRank1Modal] = useState(false);
    const [showRank2Modal, setShowRank2Modal] = useState(false);
    const [isRankEventModalOpen, setIsRankEventModalOpen] = useState(false);
    const [rankEventModalData, setRankEventModalData] = useState(null);
    const [activeTopRanking, setActiveTopRanking] = useState('interest');

    const formatForJava = (date) => {
        const pad = (n) => (n < 10 ? '0' + n : n);

        const yyyy = date.getFullYear();
        const mm = pad(date.getMonth() + 1);
        const dd = pad(date.getDate());
        const hh = pad(date.getHours());
        const min = pad(date.getMinutes());
        const ss = pad(date.getSeconds());

        return `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}`;
    };
    const formatEventDate = (value) => {
        if (!value) return '';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
            return value;
        }

        // Formatujemy samą datę
        const datePart = date.toLocaleDateString('pl-PL', {
            weekday: 'short',
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        });

        // Formatujemy samą godzinę (numeric usuwa zero z przodu)
        let timePart = date.toLocaleTimeString('pl-PL', {
            hour: 'numeric',
            minute: '2-digit'
        });

        // Dodatkowe zabezpieczenie na wypadek, gdyby system i tak dodał zero (np. "09:15")
        timePart = timePart.startsWith('0') ? timePart.substring(1) : timePart;

        // Łączymy znakiem nowej linii
        return `${datePart}`;
    };

    const formatEventTime = (value) => {
        if (!value) return '';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
            return '';
        }
        let timePart = date.toLocaleTimeString('pl-PL', { hour: 'numeric', minute: '2-digit' });
        timePart = timePart.startsWith('0') ? timePart.substring(1) : timePart;
        return `${timePart}`;
    };

    const [data1, setData1] = useState([]);
    const [data1Female, setData1Female] = useState([]);
    const [data1Male, setData1Male] = useState([]);
    const [data1Other, setData1Other] = useState([]);

    const VISIBLE_BARS_COUNT = 7; // Ile dni widzimy naraz
    const [barStartIndex, setBarStartIndex] = useState(0);

    const now = new Date();
    const sevenDaysBefore = new Date();
    sevenDaysBefore.setDate(now.getDate() - 7);

    const startDateTemp = now.getDate - VISIBLE_BARS_COUNT;
    const [endDate, setEndDate] = useState(now);
    const [startDate, setStartDate] = useState(sevenDaysBefore);

    const handleBarPrev = () => {
        // 1. Tworzymy nowe kopie obiektów na podstawie aktualnego stanu
        const newStart = new Date(startDate);
        const newEnd = new Date(endDate);

        // 2. Odejmujemy jeden dzień
        newStart.setDate(newStart.getDate() - 1);
        newEnd.setDate(newEnd.getDate() - 1);

        // 3. Aktualizujemy stan
        setStartDate(newStart);
        setEndDate(newEnd);

        // 4. Logowanie (używamy zmiennych lokalnych, bo stan jeszcze się nie zmienił)
        console.log("New Start date:", newStart, "New End date:", newEnd);
    };

    const handleBarNext = () => {
        const newStart = new Date(startDate);
        const newEnd = new Date(endDate);

        newStart.setDate(newStart.getDate() + 1);
        newEnd.setDate(newEnd.getDate() + 1);

        setStartDate(newStart);
        setEndDate(newEnd);
        console.log("New Start:", newStart, "New End:", newEnd);
    };

    const handleBarPrev7 = () => {
        const newStart = new Date(startDate);
        const newEnd = new Date(endDate);

        newStart.setDate(newStart.getDate() - 7);
        newEnd.setDate(newEnd.getDate() - 7);

        setStartDate(newStart);
        setEndDate(newEnd);
        console.log("New Start:", newStart, "New End:", newEnd);
    };

    const handleBarNext7 = () => {
        const newStart = new Date(startDate);
        const newEnd = new Date(endDate);

        newStart.setDate(newStart.getDate() + 7);
        newEnd.setDate(newEnd.getDate() + 7);

        setStartDate(newStart);
        setEndDate(newEnd);
        console.log("New Start:", newStart, "New End:", newEnd);
    };

    const [visibleDataSource, setVisibleDataSource] = useState({
        All: true,
        Female: false,
        Male: false,
        Other: false,
    });

    const selectDataSource = (key) => {
        setVisibleDataSource((prev) => {
            if (prev[key]) return prev;
            return {
                All: false,
                Female: false,
                Male: false,
                Other: false,
                [key]: true,
            };
        });
    };

    const activeData1 = visibleDataSource.Male
        ? data1Male
        : visibleDataSource.Other
            ? data1Other
            : visibleDataSource.Female
                ? data1Female
                : data1;

    // Dla pojedynczego wydarzenia (nowe API) pokazujemy całość, bez okna 7 dni
    const visibleData1 = (Number(selectedEventId) > 0)
        ? data1
        : activeData1.slice(barStartIndex, barStartIndex + VISIBLE_BARS_COUNT);


    // Checkboxy sterujące słupkami (co ma się wyświetlać na wykresie)
    const [visibleBars, setVisibleBars] = useState({
        Przeglad: true,
        Paczka: true,
        Ulubione: true,
    });
    const [visibleBarsDemography, setVisibleBarsDemography] = useState({
        all: true,
        female: false,
        male: false,
        other: false,
    });

    const toggleBar = (key) => {
        setVisibleBars((prev) => {
            const enabledCount = Object.values(prev).filter(Boolean).length;
            const isCurrentlyEnabled = prev[key];

            // Nie pozwól odznaczyć ostatniego zaznaczonego checkboxa
            if (isCurrentlyEnabled && enabledCount === 1) return prev;

            return { ...prev, [key]: !prev[key] };
        });
    };

    const toggleBarDemography = (key) => {
        setVisibleBarsDemography((prev) => {
            if (prev[key]) return prev;

            return {
                all: false,
                female: false,
                male: false,
                other: false,
                [key]: true,
            };
        });
    };


    const data2 = [
        { dzien: '1-07', Przeglad: 10 },
        { dzien: '2-07', Przeglad: 25 },
        { dzien: '3-07', Przeglad: 20 },
        { dzien: '4-07', Przeglad: 5 },
        { dzien: '5-07', Przeglad: 70 },
        { dzien: '6-07', Przeglad: 55 },
        { dzien: '7-07', Przeglad: 25 },
    ];

    // Dane wykresu wieku (z API /demographics/age; pusty, gdy brak wybranego wydarzenia)
    const [viewersAgeData, setViewersAgeData] = useState([]);
    const [participantsAgeData, setParticipantsAgeData] = useState([]);
    // Źródło wykresu wieku: 'viewers' (oglądający) albo 'participants' (uczestnicy paczek)
    const [ageSource, setAgeSource] = useState('viewers');
    const ageChartData = ageSource === 'participants' ? participantsAgeData : viewersAgeData;
    // Zakres czasu dla pojedynczego wydarzenia ustalony na sztywno: "Całość" (brak dateFrom/dateTo)
    const isSingleEventSelected = Number(selectedEventId) > 0;

    const toNumber = (v) => Number(v) || 0;

    // Backend zwraca rozbicia jako procenty (np. K: 55.0) - przeliczamy je na liczebności względem sumy
    const breakdownToCounts = (total, breakdown, definitions) => {
        const values = definitions.map((d) => toNumber(breakdown?.[d.key] ?? breakdown?.[d.key.toLowerCase()]));
        const sum = values.reduce((a, b) => a + b, 0);
        const looksLikePercent = sum > 0 && sum <= 101;
        return values.map((v) => looksLikePercent ? (toNumber(total) * v) / 100 : v);
    };

    const countsToPie = (counts, definitions) => {
        const sum = counts.reduce((a, b) => a + b, 0);
        return definitions.map((d, i) => ({
            name: d.name,
            value: Math.round(counts[i]),
            percentage: sum > 0 ? Math.round((counts[i] / sum) * 100) : 0,
        }));
    };

    // const [showUsers2Modal, setShowUsers2Modal] = useState(false);

    const [pieData, setPieData] = useState([
        { name: 'Kobiety', value: 0, percentage: 0 },
        { name: 'Mężczyźni', value: 0, percentage: 0 },
        { name: 'Inna', value: 0, percentage: 0 },
    ]);

    const [pieData2, setPieData2] = useState ([
        { name: 'Kobiety', value: 0, percentage: 0 },
        { name: 'Mężczyźni', value: 0, percentage: 0 },
        { name: 'Inna', value: 0, percentage: 0 },
    ]);

    const [pieData3, setPieData3] = useState ([
        { name: 'Nowi', value: 0, percentage: 0 },
        { name: 'Powracający', value: 0, percentage: 0 },
    ]);
    const dataInsidePie = "156";

    const PIE_COLORS = ['#EE8F3B', '#7D959F', '#0aa2d5'];

    const [data4, setData4] = useState([
        { name: 'Twoje wydarzenie miało o {1} większe zainteresowanie (mierzone liczbą osób tworzących paczki i dołączających do nich) niż średnia w tej kategorii.', value: '' },
        { name: 'Współczynnik konwersji. {2} osób odwiedziło stronę Twojego wydarzenia, z czego {3} zdecydowały się dołączyć.', value: '' },
    ]);

    const calculateSum = (data) => {
        return data.reduce((acc, item) => acc + (item.value || 0), 0);
    };

    const [eventsDataForTiles, setEventsDataForTiles] = useState([]);
    const [topEventsByInterest, setTopEventsByInterest] = useState([]);
    const [topEventsByPackages, setTopEventsByPackages] = useState([]);

    const handleSidebarClick = (tabName) => {
        dispatch(toggleActiveTab(tabName));
    };

    useEffect(() => {
        dispatch(setEventsListStartIndex(0));
    }, [eventsDataForTiles.length, dispatch]);

    useEffect(() => {
        fetchBothTopEvents();
    }, [dropdown1Value, dropdown2Value]);

    // const visibleEvents = eventsDataForTiles.slice(eventsListStartIndex, eventsListStartIndex + 5);
    const visibleEvents = eventsDataForTiles.slice(0 , eventsDataForTiles.length);
    const canScrollUp = eventsListStartIndex > 0;
    const canScrollDown = eventsListStartIndex + 5 < eventsDataForTiles.length;
    const showNavigationButtons = false; //eventsDataForTiles.length > 5;

    const handleEventClick = (eventId) => {
        dispatch(setSelectedEvent(Number(eventId)));
    };

    const openRankEventModal = (event) => {
        dispatch(setSelectedEvent(event.id));
        setRankEventModalData(event);
        setIsRankEventModalOpen(true);
    };

    const closeRankEventModal = () => {
        setIsRankEventModalOpen(false);
        setRankEventModalData(null);
    };

    useEffect(() => {
        if (selectedEventId) {
            setDropdown3Value(selectedEventId.toString());
        } else {
            setDropdown3Value('0');
        }

    }, [selectedEventId]);

    const handleDropdown3Change = (e) => {
        const newValue = e.target.value;
        setDropdown3Value(newValue);

        // Jeśli wybrano '0' (Wszystkie), a mamy zaznaczony event - odznaczamy go.
        // Jeśli wybrano konkretne ID - aktualizujemy Redux.
        if (newValue === '0') {
            if (selectedEventId !== 0) {
                dispatch(setSelectedEvent(0));
            }
        } else {
            const numericId = parseInt(newValue, 10);
            if (selectedEventId !== numericId) {
                dispatch(setSelectedEvent(numericId));
            }
        }
    };

    const [eventsLoading, setEventsLoading] = useState(false);
    const [eventsError, setEventsError] = useState(null);
    const [statsLoading, setStatsLoading] = useState(false);
    const [statsError, setStatsError] = useState(null);
    const [rankingsLoading, setRankingsLoading] = useState(false);
    const [rankingsError, setRankingsError] = useState(null);

    const ensureTokensValid = async () => {
        const tokensValid = await ApiService.checkTokenExpiration();
        return !!tokensValid;
    };

    const fetchStatistics = async () => {
        if (selectedEventId === null) {
            return;
        }
        if (Number(selectedEventId) > 0) {
            const tokensValid = await ensureTokensValid();
            if (!tokensValid) {
                return;
            }
            setStatsLoading(true);
            setStatsError(null);
            try {
                // Pojedyncze wydarzenie: nowe API /api/v1/statistics/events/{id}/..., zakres "Całość"
                await fetchEventsStatistics([Number(selectedEventId)]);
            } finally {
                setStatsLoading(false);
            }
            return;
        }
        // Wszystkie wydarzenia: dotychczasowe endpointy
        setViewersAgeData([]);
        setParticipantsAgeData([]);
        await fetchAllEventsStatistics();
    }

    // Statystyki z nowego API (/api/v1/statistics/events/{id}/...), zakres: całość (bez dateFrom/dateTo)
    const fetchEventsStatistics = async (eventIds) => {
        const genderDefs = [
            { key: 'K', name: 'Kobiety' },
            { key: 'M', name: 'Mężczyźni' },
            { key: 'I', name: 'Inna' },
        ];
        const visitorDefs = [{ key: 'NEW', name: 'Nowi' }, { key: 'RETURNING', name: 'Powracający' }];

        const results = await Promise.all(eventIds.map(async (id) => {
            const [summary, age, activity, participants] = await Promise.allSettled([
                ApiService.getStatisticsEventSummary(id, {}),
                ApiService.getStatisticsEventDemographicsAge(id, {}),
                ApiService.getStatisticsEventActivitySeries(id, { interval: 'DAY' }),
                ApiService.getBunchAgeDemographics(id, {}),
            ]);
            return { summary, age, activity, participants };
        }));

        const firstError = results
            .flatMap((r) => [r.summary, r.age, r.activity])
            .find((r) => r.status === 'rejected');
        if (firstError) setStatsError(firstError.reason);

        // --- Podsumowanie ---
        const summaries = results.filter((r) => r.summary.status === 'fulfilled' && r.summary.value).map((r) => r.summary.value);
        const sumCounts = (pick, defs) => {
            const counts = defs.map(() => 0);
            summaries.forEach((s) => {
                const section = pick(s);
                const c = breakdownToCounts(section?.total, section?.genderBreakdown ?? section?.breakdown, defs);
                c.forEach((v, i) => { counts[i] += v; });
            });
            return countsToPie(counts, defs);
        };
        const sumTotal = (pick) => summaries.reduce((acc, s) => acc + toNumber(pick(s)?.total), 0);

        const viewsTotal = sumTotal((s) => s.views);
        const packsTotal = sumTotal((s) => s.packageParticipants);

        setPieData(sumCounts((s) => s.views, genderDefs));
        setPieData2(sumCounts((s) => s.packageParticipants, genderDefs));
        setPieData3(sumCounts((s) => s.visitorTypes, visitorDefs));

        const avg = (values) => values.length ? values.reduce((a, b) => a + b, 0) / values.length : 0;
        const boost = Math.round(avg(summaries.map((s) => toNumber(s.conversionInsight?.categoryAverageComparisonPercentage))));
        const conversion = summaries.length === 1
            ? Math.round(toNumber(summaries[0].conversionInsight?.conversionRatePercentage))
            : (viewsTotal > 0 ? Math.round((packsTotal / viewsTotal) * 100) : 0);
        const absBoost = Math.abs(boost);
        const boostLabel = boost < 0 ? ' niższa ' : ' większe ';
        const boostTxt = boost < 0
            ? `Liczba osób dołączających do paczek przy tym wydarzeniu jest obecnie o ${absBoost}%${boostLabel}od średniej w tej kategorii.`
            : `Twoje wydarzenie miało o ${absBoost}%${boostLabel}zainteresowanie (mierzone liczbą osób tworzących paczki i dołączających do nich) niż średnia w tej kategorii.`;
        setData4([
            { name: boostTxt, value: `${absBoost}%${boostLabel}` },
            { name: `Współczynnik konwersji. ${viewsTotal} otworzyło Twoje wydarzenie, a ${packsTotal} zdecydowały się dołączyć (tworząc lub dołączając do paczki)`, value: `${conversion}%` },
        ]);

        // --- Wiek (średnia ważona liczbą wyświetleń wydarzenia) ---
        const ages = results
            .map((r) => ({ res: r.age, weight: r.summary.status === 'fulfilled' ? Math.max(1, toNumber(r.summary.value?.views?.total)) : 1 }))
            .filter((a) => a.res.status === 'fulfilled' && a.res.value);
        const groups = ages.map((a) => a.res.value.ageGroups).find((g) => Array.isArray(g) && g.length) || [];
        const weightSum = ages.reduce((acc, a) => acc + a.weight, 0);
        const weighted = (gender, group) => weightSum > 0
            ? ages.reduce((acc, a) => acc + toNumber(a.res.value.data?.[gender]?.[group]) * a.weight, 0) / weightSum
            : 0;
        const round1 = (v) => Math.round(v * 10) / 10;
        setViewersAgeData(groups.map((group) => {
            const female = round1(weighted('K', group));
            const male = round1(weighted('M', group));
            const other = round1(weighted('I', group));
            return {
                key: String(group).replace('–', '-'),
                all: round1(female + male + other),
                male,
                female,
                other,
            };
        }));

        // --- Wiek uczestników paczek (sumowane liczebności po przedziałach) ---
        const participantsByKey = {};
        results.forEach((r) => {
            if (r.participants.status !== 'fulfilled' || !Array.isArray(r.participants.value)) return;
            r.participants.value.forEach((item) => {
                const key = String(item?.key ?? '').replace('–', '-');
                const row = participantsByKey[key] || (participantsByKey[key] = { key, all: 0, male: 0, female: 0, other: 0 });
                row.all += toNumber(item?.all);
                row.male += toNumber(item?.male);
                row.female += toNumber(item?.female);
                row.other += toNumber(item?.other);
            });
        });
        const orderedKeys = groups.length ? groups.map((g) => String(g).replace('–', '-')) : Object.keys(participantsByKey);
        setParticipantsAgeData(orderedKeys.map((key) => participantsByKey[key] || { key, all: 0, male: 0, female: 0, other: 0 }));

        // --- Aktywność (sumowana po etykiecie) ---
        const activityByLabel = {};
        results.forEach((r) => {
            if (r.activity.status !== 'fulfilled') return;
            const payload = r.activity.value;
            console.log('Statistics activity series: ', payload);
            const firstArrayInPayload = (payload && typeof payload === 'object' && !Array.isArray(payload))
                ? Object.values(payload).find((v) => Array.isArray(v))
                : undefined;
            const unwrap = payload?.timeSeries ?? payload?.data ?? payload?.series ?? payload?.content ?? firstArrayInPayload ?? payload;
            let items = [];
            if (Array.isArray(unwrap)) {
                items = unwrap;
            } else if (unwrap && typeof unwrap === 'object') {
                // mapa { "2026-03-01": { viewing, packs, favorites } }
                items = Object.entries(unwrap).map(([key, v]) =>
                    (v && typeof v === 'object') ? { label: key, ...v } : { label: key, viewing: v });
            }
            items.forEach((item, index) => {
                const label = String(item?.label ?? item?.date ?? item?.day ?? item?.period ?? index);
                const row = activityByLabel[label] || (activityByLabel[label] = { dzien: label, Przeglad: 0, Paczka: 0, Ulubione: 0 });
                row.Przeglad += toNumber(item?.viewing ?? item?.views);
                row.Paczka += toNumber(item?.packs ?? item?.packages);
                row.Ulubione += toNumber(item?.favorites ?? item?.likes);
            });
        });
        setData1(Object.values(activityByLabel).sort((a, b) => String(a.dzien).localeCompare(String(b.dzien))));
    };

    const fetchAllEventsStatistics = async () => {
        const tokensValid = await ensureTokensValid();
        if (!tokensValid) {
            return;
        }
        if (selectedEventId === null) {
            return;
        }
        const eventId =  selectedEventId;
        setStatsLoading(true);
        setStatsError(null);
        try {
            const response = await ApiService.getPieStatisticsViews(eventId);
            console.log('Statistics Part 1: ', response)
            setPieData( [
                {
                    name: 'Kobiety',
                    value: response.data.totalViewsBySex.FEMALE,
                    percentage: response.data.totalViewsBySexPercentage.FEMALE
                },
                {
                    name: 'Mężczyźni',
                    value: response.data.totalViewsBySex.MALE,
                    percentage: response.data.totalViewsBySexPercentage.MALE
                },
                {
                    name: 'Inna',
                    value: response.data.totalViewsBySex.OTHER,
                    percentage: response.data.totalViewsBySexPercentage.OTHER
                },
            ]);
        } catch (error) {
            setStatsError(error);
        }

        try {
            const response = await ApiService.getPieStatisticsBunches(eventId);
            console.log('Statistics Part 2: ', response)
            setPieData2([
                {
                    name: 'Kobiety',
                    value: response.data.numberOfParticipantsBySex.FEMALE,
                    percentage: response.data.numberOfParticipantsBySexPercentage.FEMALE
                },
                {
                    name: 'Mężczyźni',
                    value: response.data.numberOfParticipantsBySex.MALE,
                    percentage: response.data.numberOfParticipantsBySexPercentage.MALE
                },
                {
                    name: 'Inna',
                    value: response.data.numberOfParticipantsBySex.OTHER,
                    percentage: response.data.numberOfParticipantsBySexPercentage.OTHER
                },
            ]);
        } catch (error) {
            setStatsError(error);
        }

        try {
            const response = await ApiService.getPieStatisticsUsers(eventId);

            console.log('Statistics Part 3: ', response);
            setPieData3([
                {
                    name: 'Nowi',
                    value: response.data.newParticipants,
                    percentage: response.data.newParticipantsPercentage },
                {
                    name: 'Powracający',
                    value: response.data.oldParticipants,
                    percentage: response.data.oldParticipantsPercentage },
            ]);
        } catch (error) {
            setStatsError(error);
        }

        if ( selectedEventId !== 0) {
            try {
                const response = await ApiService.getComparisonStatistics(eventId);
                console.log('Statistics Part 4: ', response)

                let x;
                let txt;
                let basicTxt;
                if (response.data.comparisonEventWithCategory <0) {
                    txt = ' niższa ';
                    x = - response.data.comparisonEventWithCategory;
                    basicTxt = `Liczba osób dołączających do paczek przy tym wydarzeniu jest obecnie o ${x}%${txt} od średniej w tej kategorii.`;
                } else {
                    txt = ' większe ';
                    x = response.data.comparisonEventWithCategory;
                    basicTxt = `Twoje wydarzenie miało o ${x}%${txt} zainteresowanie (mierzone liczbą osób tworzących paczki i dołączających do nich) niż średnia w tej kategorii.`;
                }

                setData4([
                    { name: basicTxt , value: `${x}%${txt}` },
                    { name: `Współczynnik konwersji. ${response.data.numberOfViews} otworzyło Twoje wydarzenie, a ${response.data.eventBunchesParticipantsCount} zdecydowały się dołączyć (tworząc lub dołączając do paczki)`, value: `${response.data.conversionRate}%` },
                ])
            } catch (error) {
                setStatsError(error);
            }
        }


        try {
            const from = formatForJava(startDate);
            const to = formatForJava(endDate);

            const response = await ApiService.getChartOneStatistics(from, to, eventId);
            console.log('Statistics Part 5: ', response);

            // 1. Pobieramy obiekt mapy z response.data
            const rawData = response.data;

            // 2. Przekształcamy mapę na tablicę obiektów pasującą do Twojej struktury
            const mappedData = Object.entries(rawData)
                .map(([dateKey, values]) => ({
                    // Skracamy format "18-01-26" do "18-01" dla lepszej czytelności na wykresie
                    dzien: dateKey || 0,
                    Przeglad: values.views || 0,
                    Paczka: values.bunches || 0,
                    Ulubione: values.favorites || 0
                }))
                .sort((a, b) => {
                    // Sortowanie, aby daty na wykresie szły po kolei
                    const parseDate = (d) => {
                        const [day, month] = d.split('-').map(Number);
                        return month * 100 + day; // Proste porównanie miesiąc + dzień
                    };
                    return parseDate(a.dzien) - parseDate(b.dzien);
                });

            // 3. Zapisujemy gotową tablicę do stanu
            setData1(mappedData);

        } catch (error) {
            setStatsError(error);
        }

    //     stats by sex

        try {
            const from = formatForJava(startDate);
            const to = formatForJava(endDate);

            const response = await ApiService.getChartOneStatisticsBySex(from, to, eventId, 'FEMALE');
            console.log('Statistics Part 5: ', response);

            // 1. Pobieramy obiekt mapy z response.data
            const rawData = response.data;

            // 2. Przekształcamy mapę na tablicę obiektów pasującą do Twojej struktury
            const mappedData = Object.entries(rawData)
                .map(([dateKey, values]) => ({
                    // Skracamy format "18-01-26" do "18-01" dla lepszej czytelności na wykresie
                    dzien: dateKey || 0,
                    Przeglad: values.views || 0,
                    Paczka: values.bunches || 0,
                    Ulubione: values.favorites || 0
                }))
                .sort((a, b) => {
                    // Sortowanie, aby daty na wykresie szły po kolei
                    const parseDate = (d) => {
                        const [day, month] = d.split('-').map(Number);
                        return month * 100 + day; // Proste porównanie miesiąc + dzień
                    };
                    return parseDate(a.dzien) - parseDate(b.dzien);
                });

            // 3. Zapisujemy gotową tablicę do stanu
            setData1Female(mappedData);

        } catch (error) {
            setStatsError(error);
        }


        try {
            const from = formatForJava(startDate);
            const to = formatForJava(endDate);

            const response = await ApiService.getChartOneStatisticsBySex(from, to, eventId, 'MALE');
            console.log('Statistics Part 5: ', response);

            // 1. Pobieramy obiekt mapy z response.data
            const rawData = response.data;

            // 2. Przekształcamy mapę na tablicę obiektów pasującą do Twojej struktury
            const mappedData = Object.entries(rawData)
                .map(([dateKey, values]) => ({
                    // Skracamy format "18-01-26" do "18-01" dla lepszej czytelności na wykresie
                    dzien: dateKey || 0,
                    Przeglad: values.views || 0,
                    Paczka: values.bunches || 0,
                    Ulubione: values.favorites || 0
                }))
                .sort((a, b) => {
                    // Sortowanie, aby daty na wykresie szły po kolei
                    const parseDate = (d) => {
                        const [day, month] = d.split('-').map(Number);
                        return month * 100 + day; // Proste porównanie miesiąc + dzień
                    };
                    return parseDate(a.dzien) - parseDate(b.dzien);
                });

            // 3. Zapisujemy gotową tablicę do stanu
            setData1Male(mappedData);

        } catch (error) {
            setStatsError(error);
        }


        try {
            const from = formatForJava(startDate);
            const to = formatForJava(endDate);

            const response = await ApiService.getChartOneStatisticsBySex(from, to, eventId, 'OTHER');
            console.log('Statistics Part 5: ', response);

            // 1. Pobieramy obiekt mapy z response.data
            const rawData = response.data;

            // 2. Przekształcamy mapę na tablicę obiektów pasującą do Twojej struktury
            const mappedData = Object.entries(rawData)
                .map(([dateKey, values]) => ({
                    // Skracamy format "18-01-26" do "18-01" dla lepszej czytelności na wykresie
                    dzien: dateKey || 0,
                    Przeglad: values.views || 0,
                    Paczka: values.bunches || 0,
                    Ulubione: values.favorites || 0
                }))
                .sort((a, b) => {
                    // Sortowanie, aby daty na wykresie szły po kolei
                    const parseDate = (d) => {
                        const [day, month] = d.split('-').map(Number);
                        return month * 100 + day; // Proste porównanie miesiąc + dzień
                    };
                    return parseDate(a.dzien) - parseDate(b.dzien);
                });

            // 3. Zapisujemy gotową tablicę do stanu
            setData1Other(mappedData);

        } catch (error) {
            setStatsError(error);
        } finally {
            setStatsLoading(false);
        }


    }

    const fetchBothTopEvents = async () => {
        const tokensValid = await ensureTokensValid();
        if (!tokensValid) {
            return;
        }

        setRankingsLoading(true);
        setRankingsError(null);
        try {
            const path1 = dropdown2Value + '/' + dropdown1Value + '/INTEREST' ;
            const response1 = await ApiService.getEventsTopCharts(path1);
            //----------------------------
            // Przykładowe dane dla Top 10 wg zainteresowania
            // W przyszłości tutaj będzie prawdopodobnie osobne API call
            const mockTopByInterest = response1.data.map((event, index) => ({
                ...event,
                rank: index + 1
            }));
            setTopEventsByInterest(mockTopByInterest);

            const path2 = dropdown2Value + '/' + dropdown1Value + '/BUNCHES' ;
            const response2 = await ApiService.getEventsTopCharts(path2);

            // Przykładowe dane dla Top 10 wg paczek
            // W przyszłości tutaj będzie prawdopodobnie osobne API call
            const mockTopByPackages = response2.data.map((event, index) => ({
                ...event,
                rank: index + 1
            }));
            setTopEventsByPackages(mockTopByPackages);
            //----------------------------
        } catch (err) {
            console.error('Błąd pobierania rankingów:', err);
            setRankingsError(err.message || 'Nie udało się pobrać rankingów');
        } finally {
            setRankingsLoading(false);
        }
    }
    const [dropdown3Options, setDropdown3Options] = useState([{ id: 0, name: 'wszystkie', nameEng: 'all' }])

    const fetchEvents = async () => {
        const tokensValid = await ensureTokensValid();
        if (!tokensValid) {
            return;
        }
        setEventsLoading(true);
        setEventsError(null);

        try {
            const response = await ApiService.getEvents2();
            console.log('Pobrane eventy:', response.data);

            let eventsList = Array.isArray(response.data) ? [...response.data] : [];

            // Jeśli wybrano konkretne wydarzenie (np. z tabeli wydarzeń), upewniamy się, że znajdzie się na liście
            const currentSelectedId = selectedEventId ? Number(selectedEventId) : 0;
            if (currentSelectedId > 0 && !eventsList.some(e => Number(e.id) === currentSelectedId)) {
                try {
                    const singleEventResponse = await ApiService.getEvent(currentSelectedId);
                    if (singleEventResponse && singleEventResponse.data) {
                        eventsList = [singleEventResponse.data, ...eventsList];
                    }
                } catch (singleErr) {
                    console.error('Błąd pobierania wybranego wydarzenia:', singleErr);
                }
            }

            // Zapisz dane w state
            setEventsDataForTiles(eventsList);

            const options = eventsList.map(event => ({
                id: event.id,
                name: event.name
            }));
            setDropdown3Options([{ id: 0, name: 'wszystkie', nameEng: 'all' }, ...options]);


            await fetchBothTopEvents();

        } catch (err) {
            console.error('Błąd pobierania eventów:', err);
            setEventsError(err.message || 'Nie udało się pobrać eventów');
        } finally {
            setEventsLoading(false);
        }
    };

    const [dropdown1Options, setDropdown1Options] = useState([{ id: 0, name: 'wszystkie', nameEng: 'all' }])

    const fetchEventsCategories = async () => {
        const tokensValid = await ensureTokensValid();
        if (!tokensValid) {
            return;
        }
        try {

            const response = await ApiService.getEventsCategories()
            console.log('Pobrane kategorie:', response.data);
            setDropdown1Options([{ id: 0, name: 'wszystkie', nameEng: 'all' }, ...response.data]);
            console.log('Aktualne opcje:', dropdown1Options);

        } catch (err) {
            console.error('Błąd pobierania kategorii:', err);
        }
    };
    // Funkcja pomocnicza dla czytelności
    const isFutureOrToday = (dateToCheck) => {
        const d = new Date(dateToCheck);
        const today = new Date();
        // Zerujemy godziny, jeśli chcemy porównywać tylko dni
        today.setHours(23, 59, 59, 999);
        return d >= today;
    };

    // Pobieranie listy wydarzeń i kategorii tylko raz przy montowaniu widoku
    useEffect(() => {
        fetchEvents();
        fetchEventsCategories();
    }, []);

    // Pobieranie statystyk przy zmianie wybranego wydarzenia lub zakresu dat
    useEffect(() => {
        fetchStatistics();
    }, [selectedEventId, startDate, endDate]);

    // Upewniamy się, że jeśli wybrano konkretne wydarzenie spoza listy (np. zakończone/nieaktywne), zostanie ono dociągnięte
    useEffect(() => {
        const ensureSelectedEventInList = async () => {
            const currentSelectedId = selectedEventId ? Number(selectedEventId) : 0;
            if (currentSelectedId <= 0 || eventsLoading) {
                return;
            }

            const exists = eventsDataForTiles.some((e) => Number(e.id) === currentSelectedId);
            if (!exists) {
                try {
                    const singleEventResponse = await ApiService.getEvent(currentSelectedId);
                    if (singleEventResponse && singleEventResponse.data) {
                        const fetchedEvent = singleEventResponse.data;
                        setEventsDataForTiles((prev) => {
                            if (prev.some((e) => Number(e.id) === currentSelectedId)) return prev;
                            return [fetchedEvent, ...prev];
                        });
                        setDropdown3Options((prev) => {
                            if (prev.some((opt) => Number(opt.id) === currentSelectedId)) return prev;
                            return [...prev, { id: fetchedEvent.id, name: fetchedEvent.name }];
                        });
                    }
                } catch (singleErr) {
                    console.error('Błąd dociągania wybranego wydarzenia:', singleErr);
                }
            }
        };

        ensureSelectedEventInList();
    }, [selectedEventId, eventsDataForTiles, eventsLoading]);


    // Nowy ref dla kontenera z eventami
    const eventsScrollRef = useRef(null);

    // Funkcje do przewijania
    const scrollUp = () => {
        if (canScrollUp) {
            dispatch(setEventsListStartIndex(eventsListStartIndex - 1));
        }
    };

    const scrollDown = () => {
        if (canScrollDown) {
            dispatch(setEventsListStartIndex(eventsListStartIndex + 1));
        }
    };

    return (
    <div>
      <Menu />
      <Content>
        <div className="stats-container">
          <div className="stats-header">
            <h1 className="stats-header-title">
                <StatusUp className="stats-header-icon" />
                Statystyki
            </h1>
          </div>

          <div className="stats-content">
              <div className="stats-sidebar">
                  <div
                      className={`sidebar-item ${activeTab === 'Ogólne' ? 'active' : ''}`}
                      onClick={() => handleSidebarClick('Ogólne')}
                  >
                      Ogólne statystyki<span className="right-oriented-stats">&#10217;</span>
                  </div>
                  <div
                      className={`sidebar-item ${activeTab === 'Rankingi' ? 'active' : ''}`}
                      onClick={() => handleSidebarClick('Rankingi')}
                  >
                      Rankingi wydarzeń<span className="right-oriented-stats">&#10217;</span>
                  </div>

                  {activeTab !== 'Rankingi' && <div className="sidebar-after-item">
                      Wydarzenia

                      {showNavigationButtons && (
                          <button
                              onClick={scrollUp}
                              disabled={!canScrollUp}
                              style={{
                                  display: 'block',
                                  width: '106%',
                                  padding: '8px',
                                  marginTop: '20px',
                                  backgroundColor: canScrollUp ? '#EE8F3B' : '#ccc',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '4px',
                                  cursor: canScrollUp ? 'pointer' : 'not-allowed',
                                  fontSize: '16px',
                                  fontWeight: 'bold'
                              }}
                          >
                              ▲ Góra
                          </button>
                      )}

                      {eventsLoading && eventsDataForTiles.length === 0 ? (
                          <div style={{ padding: '16px 8px', color: '#666', fontSize: '14px' }}>
                              Ładowanie listy wydarzeń...
                          </div>
                      ) : (
                          visibleEvents.map((event, index) => (
                              <div
                                  key={event.id || index}
                                  style={{ marginBottom: '-45px', minWidth: '460px', maxWidth: '500px', marginTop: '17px', transform: 'scale(0.65)', transformOrigin: 'left top', cursor: 'pointer' }}
                                  onClick={() => handleEventClick(event.id)}
                              >
                                  <CustomTile
                                      imageUrl={event.image_hash_code ? `/api/events-images/${event.image_hash_code}` : (event.imageUrl || '')}
                                      textLines={[
                                          event.name || '',
                                          [event.place, event.city].filter(Boolean).join(', '),
                                          formatEventDate(event.startDate),
                                          formatEventTime(event.startDate)]}

                                      backgroundColor={Number(selectedEventId) === Number(event.id) ? "#fff5e6" : "#F4F4F4"}
                                      showNumber={false}
                                      useAuth={true}
                                  />
                              </div>
                          ))
                      )}

                      {showNavigationButtons && (
                          <button
                              onClick={scrollDown}
                              disabled={!canScrollDown}
                              style={{
                                  display: 'block',
                                  width: '106%',
                                  padding: '8px',
                                  marginTop: '28px',
                                  backgroundColor: canScrollDown ? '#EE8F3B' : '#ccc',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '4px',
                                  cursor: canScrollDown ? 'pointer' : 'not-allowed',
                                  fontSize: '16px',
                                  fontWeight: 'bold'
                              }}
                          >
                              ▼ Dół
                          </button>
                      )}

                  </div>}
              </div>

              {/********************************/}
              {/*    zakładka ogólne początek  */}

              {activeTab === 'Ogólne' && <div className="stats-main">
                  <div className={"line-right-aligned"}>
                      <div className="line-label">Lista wydarzeń: </div>
                      <CustomDropdown
                          placeholder="Wybierz opcję..."
                          options={dropdown3Options.map((opt, index) => ({
                              value: opt.id.toString(),
                              label: opt.name
                          }))}
                          value={dropdown3Value}
                          onChange={handleDropdown3Change}
                          hoverClass="hover-active"
                          activeClass="is-active"
                      />
                  </div>

                  <div className="grid-chart">
                      <div className="chart-with-frame flex-line-item">
                          <div className='header-line'><ThreePeople className='orange'/>Wyświetlenia <InfoIcon onClick={() => setShowViewsModal(true)} /></div>

                          <div className="stats-pie-container">
                              {/* Wykres */}
                              <div className="stats-pie-wrapper">
                                  <ResponsiveContainer width="100%" height="100%">
                                      <PieChart>
                                          <Pie
                                              data={pieData}
                                              cx="50%"                  // Teraz może być wyśrodkowany
                                              cy="50%"
                                              innerRadius={60}
                                              outerRadius={100}
                                              fill="#8884d8"
                                              dataKey="value"
                                              paddingAngle={3}
                                              labelLine={false}
                                          >
                                              {pieData.map((entry, index) => (
                                                  <Cell
                                                      key={`cell-${index}`}
                                                      fill={PIE_COLORS[index % PIE_COLORS.length]}
                                                  />
                                              ))}
                                          </Pie>
                                      </PieChart>
                                  </ResponsiveContainer>

                                  {/* Tekst w środku */}
                                  <div className="stats-pie-center-label">
                                      <div className="stats-pie-center-text">
                                          {calculateSum(pieData)}
                                      </div>
                                  </div>
                              </div>

                              {/* Własna legenda obok/pod wykresem */}
                              <div className="stats-pie-legend">
                                  {pieData.map((entry, index) => (
                                      <div key={index} className="stats-pie-legend-item">
                                          <div
                                              className="stats-pie-legend-dot"
                                              style={{backgroundColor: PIE_COLORS[index]}}
                                          />
                                          <span className="stats-pie-legend-text">
                                                  {entry.name}<br/>{entry.value} - {entry.percentage}%
                                              </span>
                                      </div>
                                  ))}
                              </div>
                          </div>

                      </div>
                      <div className="chart-with-frame flex-line-item">
                          <div className='header-line'><ThreePeople className='orange'/>Uczestnicy paczek<InfoIcon onClick={() => setShowUsersModal(true)} /></div>

                          <div className="stats-pie-container">
                              {/* Wykres */}
                              <div className="stats-pie-wrapper">
                                  <ResponsiveContainer width="100%" height="100%">
                                      <PieChart>
                                          <Pie
                                              data={pieData2}
                                              cx="50%"                  // Teraz może być wyśrodkowany
                                              cy="50%"
                                              innerRadius={60}
                                              outerRadius={100}
                                              fill="#8884d8"
                                              dataKey="value"
                                              paddingAngle={3}
                                              labelLine={false}
                                          >
                                              {pieData2.map((entry, index) => (
                                                  <Cell
                                                      key={`cell-${index}`}
                                                      fill={PIE_COLORS[index % PIE_COLORS.length]}
                                                  />
                                              ))}
                                          </Pie>
                                      </PieChart>
                                  </ResponsiveContainer>

                                  {/* Tekst w środku */}
                                  <div className="stats-pie-center-label">
                                      <div className="stats-pie-center-text">
                                          {calculateSum(pieData2)}
                                      </div>
                                  </div>
                              </div>

                              {/* Własna legenda obok/pod wykresem */}
                              <div className="stats-pie-legend">
                                  {pieData2.map((entry, index) => (
                                      <div key={index} className="stats-pie-legend-item">
                                          <div
                                              className="stats-pie-legend-dot"
                                              style={{backgroundColor: PIE_COLORS[index]}}
                                          />
                                          <span className="stats-pie-legend-text">
                                                  {entry.name}<br/>{entry.value} - {entry.percentage}%
                                              </span>
                                      </div>
                                  ))}
                              </div>
                          </div>

                      </div>


                      <div className="chart-with-frame flex-line-item">
                          <div className='header-line'><ThreePeople className='orange'/>Użytkownicy: nowi vs powracający<InfoIcon onClick={() => setShowUsers2Modal(true)} /></div>

                          <div className="stats-pie-container">
                              {/* Wykres */}
                              <div className="stats-pie-wrapper">
                                  <ResponsiveContainer width="100%" height="100%">
                                      <PieChart>
                                          <Pie
                                              data={pieData3}
                                              cx="50%"                  // Teraz może być wyśrodkowany
                                              cy="50%"
                                              innerRadius={60}
                                              outerRadius={100}
                                              fill="#8884d8"
                                              dataKey="value"
                                              paddingAngle={3}
                                              labelLine={false}
                                          >
                                              {pieData3.map((entry, index) => (
                                                  <Cell
                                                      key={`cell-${index}`}
                                                      fill={PIE_COLORS[index % PIE_COLORS.length]}
                                                  />
                                              ))}
                                          </Pie>
                                      </PieChart>
                                  </ResponsiveContainer>

                                  {/* Tekst w środku */}
                                  <div className="stats-pie-center-label">
                                      <div className="stats-pie-center-text">
                                          {calculateSum(pieData3)}
                                      </div>
                                  </div>
                              </div>

                              {/* Własna legenda obok/pod wykresem */}
                              <div className="stats-pie-legend">
                                  {pieData3.map((entry, index) => (
                                      <div key={index} className="stats-pie-legend-item">
                                          <div
                                              className="stats-pie-legend-dot"
                                              style={{backgroundColor: PIE_COLORS[index]}}
                                          />
                                          <span className="stats-pie-legend-text">
                                                  {entry.name}<br/>{entry.value} - {entry.percentage}%
                                              </span>
                                      </div>
                                  ))}
                              </div>
                          </div>

                      </div>


                      {/*{ !(dropdown3Value === '0') && (*/}
                          <div className="chart-with-frame-orange flex-line-item last-grow"
                               style={{
                                   visibility: dropdown3Value === '0' ? 'hidden' : 'visible',
                                   height: dropdown3Value === '0' ? '0px' : 'auto',
                                   padding: dropdown3Value === '0' ?  '0px' : '20px'}}
                          >
                              <div className='header-line'>
                                  <StatusUp className='orange' />
                                  Podsumowanie
                              </div>

                              <div className="summary-horizontal-container">
                                  {data4.map((entry, index) => (
                                      <div key={index} className='summary-card'>
                                          <div className='text'>{entry.name}</div>
                                          <div className='text-rounded-rectangle-2'>{entry.value}</div>
                                      </div>
                                  ))}
                              </div>
                          </div>
                      {/*)}*/}
                  </div>


                  {/*<UniversalLineWithComponents*/}
                  {/*    basicStyle='line-with-components-without-borders-top-and-bottom-margin'*/}
                  {/*    leftSide={[*/}

                  {/*        // {*/}
                  {/*        //     component: customButton,*/}
                  {/*        //     props: {*/}
                  {/*        //         name: 'Aktywność użytkowników',*/}
                  {/*        //         baseClass: (activeChart === 'Aktywność użytkowników') ? 'custom-button-white-buttons-in-row-stats active' : 'custom-button-white-buttons-in-row-stats',*/}
                  {/*        //         hoverClass: 'hover-effect',*/}
                  {/*        //         onClick: () => {*/}
                  {/*        //             dispatch(toggleActiveChart('Aktywność użytkowników'))*/}
                  {/*        //         },*/}
                  {/*        //     },*/}
                  {/*        // },*/}
                  {/*        // {*/}
                  {/*        //     component: customButton,*/}
                  {/*        //     props: {*/}
                  {/*        //         name: 'Wyświetlenia po promocji',*/}
                  {/*        //         baseClass: (activeChart === 'Wyświetlenia po promocji') ? 'custom-button-white-buttons-in-row-stats active' : 'custom-button-white-buttons-in-row-stats',*/}
                  {/*        //         hoverClass: 'hover-effect',*/}
                  {/*        //         onClick: () => {*/}
                  {/*        //             dispatch(toggleActiveChart('Wyświetlenia po promocji'))*/}
                  {/*        //         },*/}
                  {/*        //     },*/}
                  {/*        // },*/}

                  {/*    ]}*/}
                  {/*    rightSide={[]}/>*/}



                  {/*--------------------------------------------------------------------*/}
                  <div className="chart-with-frame-big-3">
                      <UniversalLineWithComponents
                          basicStyle='line-with-components-without-borders-top-margin stats-age-header'
                          leftSide={[{
                              component: customText,
                              props: {
                                  icon: Chart,
                                  text: 'Wiek',
                                  baseClass: 'custom-text-bold',
                              },
                          }]}
                          rightSide={[{
                              component: () => (
                                  <div className="stats-bars-filters stats-bars-filters--age-source">
                                      <label className="stats-bars-filters__item" style={{backgroundColor: ageSource === 'viewers' ? '#2F5F6D' : '#7D959F'}}>
                                          <input
                                              className="stats-bars-filters__checkbox"
                                              type="radio"
                                              name="age-source"
                                              checked={ageSource === 'viewers'}
                                              onChange={() => setAgeSource('viewers')}
                                          />
                                          Oglądający
                                      </label>
                                      <label className="stats-bars-filters__item" style={{backgroundColor: ageSource === 'participants' ? '#2F5F6D' : '#7D959F'}}>
                                          <input
                                              className="stats-bars-filters__checkbox"
                                              type="radio"
                                              name="age-source"
                                              checked={ageSource === 'participants'}
                                              onChange={() => setAgeSource('participants')}
                                          />
                                          Uczestnicy paczek
                                      </label>
                                  </div>
                              ),
                          }]}/>

                      {/* Checkboxy do wyboru słupków */}

                      <div className="stats-bars-filters">

                          <label className="stats-bars-filters__item" style={{backgroundColor: '#2F5F6D'}}>
                              <input
                                  className="stats-bars-filters__checkbox"
                                  type="checkbox"
                                  checked={visibleBarsDemography.all}
                                  onChange={() => toggleBarDemography('all')}
                              />
                              {/*<div*/}
                              {/*    className="stats-pie-legend-dot"*/}
                              {/*    style={{backgroundColor: PIE_COLORS[index]}}*/}
                              {/*/>*/}
                              Wszyscy
                          </label>
                          <label className="stats-bars-filters__item" style={{backgroundColor: '#EE8F3B'}}>
                              <input
                                  className="stats-bars-filters__checkbox"
                                  type="checkbox"
                                  checked={visibleBarsDemography.male}
                                  onChange={() => toggleBarDemography('male')}
                              />
                              {/*<div*/}
                              {/*    className="stats-pie-legend-dot"*/}
                              {/*    style={{backgroundColor: PIE_COLORS[index]}}*/}
                              {/*/>*/}
                              Mężczyźni
                          </label>

                          <label className="stats-bars-filters__item" style={{backgroundColor: '#00868B'}}>
                              <input
                                  className="stats-bars-filters__checkbox"
                                  type="checkbox"
                                  checked={visibleBarsDemography.female}
                                  onChange={() => toggleBarDemography('female')}
                              />
                              Kobiety
                          </label>

                          <label className="stats-bars-filters__item" style={{backgroundColor: '#0aa2d5'}}>
                              <input
                                  className="stats-bars-filters__checkbox"
                                  type="checkbox"
                                  checked={visibleBarsDemography.other}
                                  onChange={() => toggleBarDemography('other')}
                              />
                              Inni
                          </label>
                      </div>

                      <ResponsiveContainer>
                          <BarChart
                              data={ageChartData}
                              margin={{
                                  top: 20,
                                  right: 30,
                                  left: 0,
                                  bottom: 145,
                              }}>
                              <CartesianGrid strokeDasharray="3 0" horizontal={true} vertical={false}/>
                              <XAxis dataKey="key"/>
                              <YAxis scale="linear"
                                     tickFormatter={(value) => Math.round(value / 10) * 10}
                                     interval={0}
                                     allowDecimals={false}/>
                              <Tooltip cursor={{
                                  fill: '#3F0A0A0A',
                                  radius: [10, 10, 0, 0]
                              }}
                              />
                              {/*<Legend />*/}
                              {visibleBarsDemography.all && (
                                  <Bar dataKey="all" fill="#2F5F6D" name="Wszyscy" barSize={20}
                                       radius={[8, 8, 0, 0]}/>
                              )}
                              {visibleBarsDemography.male && (
                                  <Bar dataKey="male" fill="#EE8F3B" name="Mężczyźni" barSize={20}
                                       radius={[8, 8, 0, 0]}/>
                              )}
                              {visibleBarsDemography.female && (
                                  <Bar dataKey="female" fill="#00868B" name="Kobiety" barSize={20}
                                       radius={[8, 8, 0, 0]}/>
                              )}
                              {visibleBarsDemography.other && (
                                  <Bar dataKey="other" fill="#0aa2d5" name="Inni" barSize={20}
                                       radius={[8, 8, 0, 0]}/>
                              )}
                          </BarChart>
                      </ResponsiveContainer>
                  </div>
                  {/*--------------------------------------------------------------------*/}



                  {/*{activeChart === 'Aktywność użytkowników' && */}
                      <div className="chart-with-frame-big">
                          <UniversalLineWithComponents
                              basicStyle='line-with-components-without-borders-top-margin'
                              leftSide={[{
                                  component: customText,
                                  props: {
                                      icon: Chart,
                                      text: 'Aktywność użytkowników',
                                      baseClass: 'custom-text-bold',
                                  },
                              }]}
                              rightSide={[{
                                  component: () => isSingleEventSelected ? null : (
                                      <div className="chart-nav-buttons">
                                          <button
                                              onClick={handleBarPrev7}
                                              // disabled={barStartIndex === 0}
                                              className="nav-arrow"
                                          >❮❮</button>
                                          <button
                                              onClick={handleBarPrev}
                                              // disabled={barStartIndex === 0}
                                              className="nav-arrow"
                                          >❮</button>
                                          <button
                                              onClick={handleBarNext}
                                              disabled={new Date(endDate).setHours(0,0,0,0) >= new Date()}
                                              className="nav-arrow"
                                          >❯</button>
                                          <button
                                              onClick={handleBarNext7}
                                              disabled={new Date(endDate).getTime() + (6 * 24 * 60 * 60 * 1000) > new Date()}
                                              className="nav-arrow"
                                          >❯❯</button>
                                      </div>
                                  )
                            }]}/>

                          {/*/!* Checkboxy do wyboru słupków *!/*/}
                          {/*<div className="stats-bars-filters">*/}
                          {/*    <label className="stats-bars-filters__item" style={{backgroundColor: 'rgba(128,128,128,0.73)'}}>*/}
                          {/*        <input*/}
                          {/*            className="stats-bars-filters__checkbox"*/}
                          {/*            type="checkbox"*/}
                          {/*            checked={visibleDataSource.All}*/}
                          {/*            onChange={() => selectDataSource('All')}*/}
                          {/*        />*/}
                          {/*        Wszyscy*/}
                          {/*    </label>*/}

                          {/*    <label className="stats-bars-filters__item" style={{backgroundColor: 'rgba(128,128,128,0.73)'}}>*/}
                          {/*        <input*/}
                          {/*            className="stats-bars-filters__checkbox"*/}
                          {/*            type="checkbox"*/}
                          {/*            checked={visibleDataSource.Female}*/}
                          {/*            onChange={() => selectDataSource('Female')}*/}
                          {/*        />*/}
                          {/*        Kobiety*/}
                          {/*    </label>*/}

                          {/*    <label className="stats-bars-filters__item" style={{backgroundColor: 'rgba(128,128,128,0.73)'}}>*/}
                          {/*        <input*/}
                          {/*            className="stats-bars-filters__checkbox"*/}
                          {/*            type="checkbox"*/}
                          {/*            checked={visibleDataSource.Male}*/}
                          {/*            onChange={() => selectDataSource('Male')}*/}
                          {/*        />*/}
                          {/*        Mężczyźni*/}
                          {/*    </label>*/}

                          {/*    <label className="stats-bars-filters__item" style={{backgroundColor: 'rgba(128,128,128,0.73)'}}>*/}
                          {/*        <input*/}
                          {/*            className="stats-bars-filters__checkbox"*/}
                          {/*            type="checkbox"*/}
                          {/*            checked={visibleDataSource.Other}*/}
                          {/*            onChange={() => selectDataSource('Other')}*/}
                          {/*        />*/}
                          {/*        Inni*/}
                          {/*    </label>*/}
                          {/*</div>*/}

                          <div className="stats-bars-filters">
                              <label className="stats-bars-filters__item" style={{backgroundColor: '#2F5F6D'}}>
                                  <input
                                      className="stats-bars-filters__checkbox"
                                      type="checkbox"
                                      checked={visibleBars.Przeglad}
                                      onChange={() => toggleBar('Przeglad')}
                                  />
                                  {/*<div*/}
                                  {/*    className="stats-pie-legend-dot"*/}
                                  {/*    style={{backgroundColor: PIE_COLORS[index]}}*/}
                                  {/*/>*/}
                                  Przeglądanie wydarzenia
                              </label>

                              <label className="stats-bars-filters__item" style={{backgroundColor: '#EE8F3B'}}>
                                  <input
                                      className="stats-bars-filters__checkbox"
                                      type="checkbox"
                                      checked={visibleBars.Paczka}
                                      onChange={() => toggleBar('Paczka')}
                                  />
                                  Utworzone paczki
                              </label>

                              <label className="stats-bars-filters__item" style={{backgroundColor: '#00868B'}}>
                                  <input
                                      className="stats-bars-filters__checkbox"
                                      type="checkbox"
                                      checked={visibleBars.Ulubione}
                                      onChange={() => toggleBar('Ulubione')}
                                  />
                                  Dodanie do ulubionych
                              </label>
                          </div>


                          <ResponsiveContainer>
                              <BarChart
                                  data={visibleData1}
                                  margin={{
                                      top: 20,
                                      right: 30,
                                      left: 0,
                                      bottom: 155,
                                  }}>
                                  <CartesianGrid strokeDasharray="3 0" horizontal={true} vertical={false}/>
                                  <XAxis dataKey="dzien"/>
                                  <YAxis scale="linear"
                                         tickFormatter={(value) => Math.round(value / 10) * 10}
                                         interval={0}
                                         allowDecimals={false}/>
                                  <Tooltip cursor={{
                                      fill: '#3F0A0A0A',
                                      radius: [10, 10, 0, 0]
                                  }}
                                  />
                                  {/*<Legend />*/}
                                  {visibleBars.Przeglad && (
                                      <Bar dataKey="Przeglad" fill="#2F5F6D" name="Przeglądanie wydarzenia" barSize={20}
                                           radius={[8, 8, 0, 0]}/>
                                  )}
                                  {visibleBars.Paczka && (
                                      <Bar dataKey="Paczka" fill="#EE8F3B" name="Utworzenie paczki" barSize={20}
                                           radius={[8, 8, 0, 0]}/>
                                  )}
                                  {visibleBars.Ulubione && (
                                      <Bar dataKey="Ulubione" fill="#00868B" name="Dodanie do ulubionych" barSize={20}
                                           radius={[8, 8, 0, 0]}/>
                                  )}
                              </BarChart>
                          </ResponsiveContainer>
                      </div>
                  {/*}*/}

              {/*    /!*{activeChart === 'Wyświetlenia po promocji' && *!/*/}
              {/*        <div className="chart-with-frame-big-2 stats-chart-locked">*/}
              {/*            <div className="stats-chart-lock-overlay" aria-hidden="true">*/}
              {/*                <Lock className="stats-chart-lock-icon" />*/}
              {/*            </div>*/}
              {/*            <div className="stats-chart-content">*/}
              {/*                <UniversalLineWithComponents*/}
              {/*                    basicStyle='line-with-components-without-borders-top-margin'*/}
              {/*                    leftSide={[{*/}
              {/*                        component: customText,*/}
              {/*                        props: {*/}
              {/*                            icon: Chart,*/}
              {/*                            text: 'Wyświetlenia po promocji',*/}
              {/*                            baseClass: 'custom-text-bold',*/}
              {/*                        },*/}
              {/*                    }]}*/}
              {/*                    rightSide={[]}*/}
              {/*                />*/}
              {/*                <ResponsiveContainer width="100%" height={400}>*/}
              {/*                    <LineChart data={data2}*/}
              {/*                               margin={{*/}
              {/*                                   top: 35,*/}
              {/*                                   right: 50,*/}
              {/*                                   left: 10,*/}
              {/*                                   bottom: 0,*/}
              {/*                               }}>*/}
              {/*                        <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB"/>*/}
              {/*                        <XAxis*/}
              {/*                            dataKey="dzien"*/}
              {/*                            stroke="#6B7280"*/}
              {/*                        />*/}
              {/*                        <YAxis*/}
              {/*                            stroke="#6B7280"*/}
              {/*                        />*/}
              {/*                        <Tooltip*/}
              {/*                            cursor={{fill: '#0AE6EB20'}}*/}
              {/*                            contentStyle={{*/}
              {/*                                backgroundColor: '#ffffff',*/}
              {/*                                border: '1px solid #E5E7EB',*/}
              {/*                                borderRadius: '8px'*/}
              {/*                            }}*/}
              {/*                        />*/}
              {/*                        <Legend*/}
              {/*                            wrapperStyle={{*/}
              {/*                                color: '#333333',*/}
              {/*                                fontSize: '14px'*/}
              {/*                            }}*/}
              {/*                        />*/}
              {/*                        <ReferenceLine*/}
              {/*                            x="4-07"*/}
              {/*                            stroke="grey"*/}
              {/*                            strokeWidth={2}*/}
              {/*                            strokeDasharray="10 0"*/}
              {/*                            label={{*/}
              {/*                                value: "Start promocji",*/}
              {/*                                position: 'insideBottomLeft',*/}
              {/*                            }}*/}
              {/*                        />*/}
              {/*                        <Line*/}
              {/*                            type="monotone"*/}
              {/*                            dataKey="Przeglad"*/}
              {/*                            stroke="#00868B"*/}
              {/*                            strokeWidth={2}*/}
              {/*                            name="Liczba wyświetleń"*/}
              {/*                            dot={{fill: '#00868B', r: 4}}*/}
              {/*                            activeDot={{r: 6}}*/}
              {/*                        />*/}
              {/*                    </LineChart>*/}
              {/*                </ResponsiveContainer>*/}
              {/*            </div>*/}
              {/*        </div>*/}
              {/*/!*}*!/*/}


                  {/**********************************/}
                  {/*    zakładka rankingi początek  */}


              </div>}

              {activeTab === 'Rankingi' && (
                  <div className="stats-main">
                      <div className={"line-right-aligned"}>
                          <button
                              type="button"
                              className={`stats-top-toggle-btn ${activeTopRanking === 'interest' ? 'is-active' : ''}`}
                              onClick={() => setActiveTopRanking('interest')}
                          >
                              wg. popularności
                          </button>
                          <button
                              type="button"
                              className={`stats-top-toggle-btn ${activeTopRanking === 'packages' ? 'is-active' : ''}`}
                              onClick={() => setActiveTopRanking('packages')}
                          >
                              wg. dołączeń
                          </button>
                          <div className="filling-div"></div>

                          <CustomDropdown
                              placeholder="Wybierz opcję..."
                              options={dropdown1Options.map((opt, index) => ({
                                  value: opt.id.toString(),
                                  label: opt.name.toUpperCase()
                              }))}
                              value={dropdown1Value}
                              onChange={(e) => setDropdown1Value(e.target.value)}
                              hoverClass="hover-active"
                              activeClass="is-active"
                          />
                          <CustomDropdown
                              placeholder="Wybierz opcję..."
                              options={[
                                  { value: 'LAST_7_DAYS', label: 'Ostatnie 7 dni' },
                                  { value: 'ALL_TIME', label: 'Całość' },
                              ]}
                              value={dropdown2Value}
                              onChange={(e) => setDropdown2Value(e.target.value)}
                              hoverClass="hover-active"
                              activeClass="is-active"
                          />
                      </div>
                      <ColumnLayout className="stats-rankingsLayout" gap="lg">
                          {activeTopRanking === 'interest' && (
                              <Column
                                  header={
                                      <h2 className="stats-rankingTitle">
                                          <span className="stats-rankingTitle__top">Top {dropdown1Value === '0' ? 10 : 5}</span> wydarzeń według polubień
                                          <InfoIcon onClick={() => setShowRank1Modal(true)} />
                                      </h2>
                                  }

                                  className = "stats-rankingColumn"
                              >
                                  {rankingsLoading ? (
                                      <p>Ładowanie...</p>
                                  ) : (
                                      topEventsByInterest.length > 0 ?
                                      topEventsByInterest.map((event, index) => (
                                          <div
                                              key={event.id || index}
                                              className="stats-rankingTileWrapper"
                                              onClick={() => openRankEventModal(event)}
                                          >
                                              {/*//todo tutaj edytować rodzaj kafelka pełny/niepełny*/}
                                              <CustomTile
                                                  imageUrl={`/api/events-images/${event.image_hash_code}`}
                                                  // textLines={
                                                  //     dropdown1Value === '0'
                                                  //         ? [event.name]
                                                  //         : [event.name, event.place + ', ' + event.city, event.date]
                                                  // }
                                                  textLines={
                                                      [event.name,
                                                       event.place + ', ' + event.city,
                                                       formatEventDate(event.startDate),
                                                       formatEventTime(event.startDate)]
                                                  }
                                                  backgroundColor={index < 3 ? "#EFEBE4" : "#F4F4F4"}
                                                  showNumber={true}
                                                  number={event.rank.toString()}
                                                  numberColor={index < 3 ? "#EE8F3B" : "#7D959F"}
                                                  useAuth={true}
                                                  tileClassName='top-custom-tile'
                                              />
                                          </div>
                                      )) : <div className="stats-rankingTileWrapper">Brak danych</div>
                                  )}
                              </Column>
                          )}

                          {activeTopRanking === 'packages' && (
                              <Column
                                  header={
                                      <h2 className="stats-rankingTitle">
                                          <span className="stats-rankingTitle__top">Top {dropdown1Value === '0' ? 10 : 5}</span> wydarzeń według dołączeń
                                          <InfoIcon onClick={() => setShowRank2Modal(true)} />
                                      </h2>
                                  }
                                  className = "stats-rankingColumn"
                              >
                                  {rankingsLoading ? (
                                      <p>Ładowanie...</p>
                                  ) : (
                                      topEventsByPackages.length > 0 ?
                                      topEventsByPackages.map((event, index) => (
                                          <div
                                              key={event.id || index}
                                              className="stats-rankingTileWrapper"
                                              onClick={() => openRankEventModal(event)}
                                          >
                                              {/*//todo tutaj edytować rodzaj kafelka pełny/niepełny*/}
                                              <CustomTile
                                                  imageUrl={`/api/events-images/${event.image_hash_code}`}
                                                  // textLines={
                                                  //     dropdown1Value === '0'
                                                  //         ? [event.name]
                                                  //         : [event.name, event.place + ', ' + event.city, event.startDate]
                                                  // }
                                                  textLines={[
                                                      event.name,
                                                      event.place + ', ' + event.city,
                                                      formatEventDate(event.startDate),
                                                      formatEventTime(event.startDate)]}
                                              backgroundColor={index < 3 ? "#EFEBE4" : "#F4F4F4"}
                                                  showNumber={true}
                                                  number={event.rank.toString()}
                                                  numberColor={index < 3 ? "#EE8F3B" : "#7D959F"}
                                                  useAuth={true}
                                                  tileClassName='top-custom-tile'
                                              />
                                          </div>
                                      )) : <div className="stats-rankingTileWrapper">Brak danych</div>
                                  )}
                              </Column>
                          )}
                      </ColumnLayout>
                  </div>
              )}
          </div>
        </div>
      </Content>
        <InfoModal
            isOpen={showViewsModal}
            onClose={() => setShowViewsModal(false)}
            title="Wyświetlenia"
            description="Wykres pokazuje łączną liczbę wyświetleń Twojego wydarzenia oraz profil użytkowników, którzy je wyświetlili."
        />
        <InfoModal
            isOpen={showUsersModal}
            onClose={() => setShowUsersModal(false)}
            title="Użytkownicy"
            description="Wykres pokazuje łączną liczbę oraz profil użytkowników, którzy utworzyli lub dołączyli do paczek związanych z Twoim wydarzeniem."
        />
        <InfoModal
            isOpen={showUsers2Modal}
            onClose={() => setShowUsers2Modal(false)}
            title="Użytkownicy"
            description="
            Nowy użytkownik – osoba, która po raz pierwszy utworzyła lub dołączyła do paczki
            pod którymkolwiek z Twoich wydarzeń.
            Powracający użytkownik – osoba, która już wcześniej brała udział w paczkach pod
            Twoimi wydarzeniami.
            "
        />

        <InfoModal
            isOpen={showRank1Modal}
            onClose={() => setShowRank1Modal(false)}
            title="Wydarzenia według polubień"
            description="Liczba użytkowników, którzy polubili wydarzenie."
        />

        <InfoModal
            isOpen={showRank2Modal}
            onClose={() => setShowRank2Modal(false)}
            title="Wydarzenia według dołączeń"
            description="Utworzenie lub dołączenie do paczki pod wydarzeniem."
        />
        {isRankEventModalOpen && rankEventModalData && (
            <div className="stats-rank-modal-overlay" onClick={closeRankEventModal}>
                <div className="stats-rank-modal" onClick={(e) => e.stopPropagation()}>
                    <button className="stats-rank-modal-close" type="button" onClick={closeRankEventModal}>
                        x
                    </button>
                    <div className="stats-rank-modal-title">{rankEventModalData.name}</div>
                    <div className="stats-rank-modal-date">
                        {formatEventDate(rankEventModalData.startDate || rankEventModalData.date)}
                    </div>
                    <div className="stats-rank-modal-tile">
                        <CustomTile
                            imageUrl={`/api/events-images/${rankEventModalData.image_hash_code}`}
                            textLines={[
                                rankEventModalData.name,
                                `${rankEventModalData.place || ''}${rankEventModalData.city ? ', ' + rankEventModalData.city : ''}`,
                                formatEventDate(rankEventModalData.startDate || rankEventModalData.date),
                                formatEventTime(rankEventModalData.startDate)
                            ]}
                            backgroundColor="#F4F4F4"
                            showNumber={false}
                            useAuth={true}
                            tiny={false}
                            tileClassName="stats-rank-modal-custom-tile"
                            imageContainerClassName="custom-image-container-big"
                            imageClassName="custom-image-rounded"
                        />
                    </div>
                    <div className="stats-rank-modal-section">Opis</div>
                    <div className="stats-rank-modal-desc">
                        {rankEventModalData.description || 'Brak opisu wydarzenia.'}
                    </div>
                </div>
            </div>
        )}
    </div>
  );
}

export default Stats;
